import React from 'react';
import { SessionTab } from '../App.tsx';
import '../styles/SessionTabs.css';

interface Props {
  activeTab: SessionTab;
  onTabChange: (tab: SessionTab) => void;
}

const TABS: { id: SessionTab; label: string }[] = [
  { id: 'chat', label: 'Chat' },
  { id: 'cowork', label: 'Cowork' },
  { id: 'coding', label: 'Coding' },
];

export default function SessionTabs({ activeTab, onTabChange }: Props) {
  return (
    <div className="session-tabs">
      {TABS.map(tab => (
        <button
          key={tab.id}
          className={`session-tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
